<template>
    <div class="ui vue dropdown" tabindex="0" :class="dropdownClass" v-on="$listeners" @click="onToggleMenu">
        <i v-if="!disabled" class="dropdown icon"></i>
        <div class="text">
            <fragment v-if="value"><slot name="text" :value="value"></slot></fragment>
            <fragment v-else>{{ placeholder }}</fragment>
        </div>
        <div class="menu" ref="menu" :class="menuClass" :style="menuStyle">
            <slot name="items" :active="value" :select="onSelectValue"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: String,
            variant: String,
            placeholder: String,
            disabled: Boolean
        },
        data() {
            return {
                menu: {
                    active: false
                }
            }
        },
        methods: {
            onSelectValue(value) {
                if (this.disabled || !this.menu.active) {
                    return
                }

                this.$emit('input', value)

                this.menu.active = false
            },
            onToggleMenu(event) {
                if (this.disabled || this.$refs.menu?.contains(event.target)) {
                    return
                }

                this.$el.focus()

                this.menu.active = !this.menu.active
            }
        },
        computed: {
            menuStyle() {
                return !this.disabled && this.menu.active ? {
                    display: 'block !important'
                } : {}
            },
            menuClass() {
                return !this.disabled && this.menu.active ? {
                    visible: true,
                    transition: true
                } : {}
            },
            dropdownClass() {
                return [{
                    active: !this.disabled && this.menu.active,
                    visible: !this.disabled && this.menu.active
                }].concat(this.variant ? this.variant.split(' ') : '')
            }
        }
    }
</script>

<style>
    .ui.dropdown {
        user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -webkit-touch-callout: none;
    }
</style>